import React, { useState, useEffect } from 'react';
import axios from "axios";
import { PHP_BACK, getUser } from '../../../../utils/Common';
import { validarSemana } from '../../../../utils/datetools';
import { getWeekNumber } from '../../../../utils/Common';
import VainillaDialog from '../../../sharecomponents/vanilladialog';
import TableHeadsData from '../../nomina/InventarioActividadesComponents/tableHeadsData';
import Formulas from '../../../sharecomponents/Formulas';
import Post from '../../../../utils/Post';
import { activeDialog } from '../../../../utils/Common';
import FormularioRegistroBloque from './formularioRegistroBloque/FromaularioRegistroBloque';

const NuevoRegistroPlanSiembra = () => {
    const formulas = new Formulas();
    const w = getWeekNumber();
    const [loader, setloader] = useState();
    const [dataFlores, setdataFlores] = useState([]);
    const [flores, setflores] = useState([]);
    const [variedades, setvariedades] = useState([]);
    const [colores, setcolores] = useState([]);
    const [registros, setregistros] = useState([]);
    const [dialog, setdialog] = useState({ show: false });
    const [form, setform] = useState({
        flor: "", variedad: "", color: "",
        plantas: 0,
        ciclopropagacion: 0,
        ciclocampo: 0,
        semcampo: `${(w[0] - 2000) > 9 ? (w[0] - 2000) : `0${(w[0] - 2000)}`}${w[1] > 9 ? w[1] : '0' + w[1]}`,
        metrosnecesarios: 0,
        talloscosecha: 0,
        camas: 0,
        germinacion: 0,
        '#charolas': 0,
        "sem.necesaria": 0,
        "semanatrasplante": `${(w[0] - 2000) > 9 ? (w[0] - 2000) : `0${(w[0] - 2000)}`}${w[1] > 9 ? w[1] : '0' + w[1]}`,
        "semanasiembra": `${(w[0] - 2000) > 9 ? (w[0] - 2000) : `0${(w[0] - 2000)}`}${w[1] > 9 ? w[1] : '0' + w[1]}`,
        "recuperacion": 0,
        cavidaddecharola: 288,
        densidad: 0,
    });
    const inputs = [
        { name: "semanasiembra", tipo: "number", size: 150, title: 'Sem. siembra' },
        { name: "ciclopropagacion", tipo: "number", size: 160, title: 'Ciclo propagación' },
        { name: "semanatrasplante", tipo: "number", size: 150, title: 'Sem. trasplante' },
        { name: "ciclocampo", tipo: "number", size: 120, title: 'Ciclo campo' },
        { name: "semcampo", tipo: "number", size: 140, title: 'Semana campo' },
        { name: "plantas", tipo: "number", size: 120, title: '# Plantas' },
        { name: "germinacion", tipo: "number", size: 120, title: 'Germinación' },
        { name: "#charolas", tipo: "number", size: 130, title: '#charolas' },
        { name: "cavidaddecharola", tipo: "number", size: 130, title: 'Cavidad charola' },
        { name: "densidad", tipo: "number", size: 120, title: 'Densidad' },
        { name: "metrosnecesarios", tipo: "number", size: 130, title: 'Metros nec.' },

        { name: "recuperacion", tipo: "number", size: 130, title: 'Recuperación' },
        { name: "talloscosecha", tipo: "number", size: 130, title: 'Tallos cosecha' },
        { name: "camas", tipo: "number", size: 100, title: 'Camas' },


        { name: "sem.necesaria", tipo: "number", size: 150, title: 'Semillas necesarias' },

    ];
    useEffect(() => {
        getFlores();
    }, []);

    const getFlores = () => {
        setloader(true);
        axios.get(PHP_BACK + "api/bloquesFlor").then((r) => {
            setdataFlores(r.data.flores);
            setflores(Object.keys(r.data.flores));
            setloader(false);
        })
            .catch((e) => console.log(e));
    }

    const listaVariedades = (dt) => {
        setcolores([]);
        if (!dt) dt = { ...form };
        if (dt.flor === "") setvariedades([]);
        else setvariedades(Object.keys(dataFlores[dt.flor].variedades));
    }

    const listaColores = (dt) => {
        if (!dt) dt = { ...form };
        if (dt.flor === "" || dt.variedad === "") setcolores([]);
        else setcolores(Object.keys(dataFlores[dt.flor].variedades[dt.variedad].colores));
    }

    const ajustarFlor = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        if (name === 'flor') listaVariedades(changeForm(['variedad', 'color', 'flor'], ['', '', value]));
        else if (name === 'variedad') listaColores(changeForm(['variedad', 'color',], [value, '']));
        else changeForm(['color',], [value]);
    }

    const changeForm = (names, values) => {
        let f = { ...form };
        for (let i = 0; i < names.length; i++) f[names[i]] = values[i];
        formulas.inicalizar_valores(f);
        if (names.includes('semanasiembra')) formulas.modificarSemanaSiembraCreacion();
        else if (names.includes("semanatrasplante")) formulas.modificarSemanaTransplanteCreacion();
        else if (names.includes("semcampo")) formulas.modificarSemanacosechaCreacion();
        else if (names.includes("ciclocampo") || names.includes("ciclopropagacion")) formulas.modificarPropagacionCampoCreacion();
        else if (names.includes("#charolas")) formulas.charolasCreacion();
        else if (names.includes("plantas")) formulas.plantasCreacion();
        else if (names.includes("talloscosecha")) formulas.tallosCreacion();
        else if (names.includes("recuperacion")) formulas.recuperacionCreacion();
        else if (names.includes("sem.necesaria")) formulas.semillasCreacion();
        else if (names.includes("germinacion")) formulas.germinacionCreacion();
        else if (names.includes("metrosnecesarios")) formulas.metrosCreacion();
        else if (names.includes("densidad")) formulas.densidadCreacion();
        formulas.values["#charolas"] = (formulas.values.germinacion > 0 && formulas.values.plantas > 0) ?
            parseFloat((formulas.values.plantas / 288 / formulas.values.germinacion).toFixed(2)) : 0;
        setform(formulas.getValues());
        return f;
    }

    const changeValue = (e) => {
        if (["semanasiembra", "semanatrasplante", "semcampo"].includes(e.target.name)) e.target.value = validarSemana(e.target.value, w)[1];
        if (["densidad", "plantas", "ciclopropagacion", "ciclocampo", "metrosnecesarios", "talloscosecha", "camas", "germinacion", "#charolas", 'sem.necesaria', "recuperacion", "cavidaddecharola"].includes(e.target.name)) {
            e.target.value = +(e.target.value);
        }
        changeForm([e.target.name], [e.target.value]);
    }

    const registroExiste = () => {
        let keys = Object.keys(form);
        for (let j = 0; j < registros.length; j++) {
            let simils = 0;
            let reg = registros[j];
            for (let i = 0; i < keys.length; i++) {
                let key = keys[i];
                if (form[key] === reg[key]) simils++;
            }
            if (simils === keys.length) return true;
        }
        return false;
    }

    const agregarRegistro = () => {
        if (registroExiste()) {
            setdialog({
                show: true,
                tipo: 'error',
                title: "El registro ya existe",
                body: `La combinación de datos que desea agregar ya fue incluida en otro registro de la lista`,
                size: 'm',
                funct: (resp) => { setdialog({ show: false }) }
            });
            return;
        }
        let regs = [...registros];
        regs.push({ ...form });
        setregistros(regs);
    }

    const generarRegistroValidar = () => {
        if (form.flor === "" || form.variedad === "" || form.color === "" ||
            form.plantas < 1 || form.ciclopropagacion < 0 || form.ciclocampo < 1 || form.metrosnecesarios <= 0 || form.talloscosecha < 1 ||
            form.camas < 0 || form.germinacion <= 0 || form['#charolas'] <= 0 || form['sem.necesaria'] < 0 || form.recuperacion <= 0 || form.cavidaddecharola <= 0 ||
            !validarSemana(form.semcampo, w)[0] || !validarSemana(form.semanatrasplante, w)[0] || !validarSemana(form.semanasiembra, w)[0]) return false;
        return true;
    }

    const eliminarRegistro = (data, index) => {
        setdialog({
            show: true,
            tipo: 'error',
            title: "¿Eliminar registro?",
            body: 'Confirme si desea eliminar registro de la lista',
            respYes: 'Si, elimnar',
            respNot: 'Volver',
            size: 'm',
            funct: (resp) => {
                if (resp) {
                    let regs = [...registros];
                    regs.splice(index, 1);
                    setregistros(regs);
                    setdialog({ show: false });
                } else { setdialog({ show: false }); }
            }
        })
    }

    const enviarExcel = async () => {
        if (!registros.length === 0) return;
        const user = getUser();
        setloader(true);
        let resp = await Post("excel/import", { data: registros, "userName": user.nombre, "userID": user.perfilId }, 'POST', setloader);
        if (!resp.estatus) {
            activeDialog(setdialog, resp.msj, 'error', "Ups, ha ocurrido un error inesperado");
            return;
        }

        activeDialog(setdialog, resp.msj, 'success', "Operación exitosa");
        setregistros([]);
    }


    return (
        <div className='col-lg-12 m-0 p-2' style={{ overflow: 'auto' }}>
            <FormularioRegistroBloque setselecciones={setform} selecciones={form} flores={dataFlores} />
            <div className='col-lg-12 m-0 p-0'></div>
            <div className='row justify-content-center p-0 m-0' style={{ overflow: 'auto' }}>
                <div className='col-lg-12 text-center mt-1'> </div>
                <button className='btn btn-dark shadow round-xl scale-05 ms-2 me-2 mt-2' style={{ backgroundColor: '#7C0062', width: '300px' }} disabled={!generarRegistroValidar()} onClick={agregarRegistro}>Agregar registro</button>
                <button className='btn btn-dark shadow round-xl scale-025 ms-2 me-2 mt-2' style={{ backgroundColor: '#005F18', width: '180px' }} disabled={registros.length === 0} onClick={enviarExcel}>Guardar</button>
                <div className='col-lg-12 mb-2 text-center'> </div>
                <div className='col-lg-12' style={{ overflow: 'auto' }}>

                    {registros.length > 0 && <TableHeadsData data={registros} heads={Object.keys(registros[0])} styleName={{ width: '100% !important', height: '48vh' }} action={eliminarRegistro} />}
                    {registros.length === 0 && <p className='text-m text-300 opacity-70 mt-2 p-0' >
                        Genere registros individuales para agregarlos al sistema y plan de siembra.
                        Llene todos los campos del formulario de arriba para que el botón <span className='text-bold' style={{ color: '#7C0062' }}>‘Agregar registro’</span>  se active y pueda agregar un registro a la lista.
                        Puede agregar tantos registros como desee, cuando tenga la lista de nuevos registros pulse el botón <span className='text-bold' style={{ color: '#005F18' }}>‘Guardar’ </span> para almacenar en el sistema los nuevos registros.
                    </p>}
                </div>

            </div>
            {loader && <div className='blur-m' style={{ width: '100vw', height: '100vh', position: 'fixed', top: 0, left: 0, zIndex: 999 }}> <div className='loader'></div></div>}
            <VainillaDialog data={dialog} />
        </div>
    )
}

export default NuevoRegistroPlanSiembra;